import React, {useState, useContext} from "react"
import {usePageLocale} from "./../../hooks/useLocale"
import { useCurrentUserHook } from "../Authentication/useUserHook"

const Table = (props) => {
  return (
    <table className="table table-stripe" id={props.id}>
      {props.children}
    </table>
  )
}

const THead = (props) => {
  return (
    <thead className={props.className}>
      {props.children}
    </thead>
  )
}

const TH = (props) => {
  return (
    <th className={props.className} onClick={()=>props.onClick && props.onClick()}>
      {props.children}
    </th>
  )
}

const TR = (props) => {
  return (
    <tr className={props.className} onClick={()=>props.onSelect && props.onSelect()}>{props.children}</tr>
  )
}

const TD = (props) => {
  return (
    <td className={props.className} 
      onClick={()=>props.onSelect && props.onSelect()}
      colSpan={props?.colSpan}>{props.children}</td>
  )
}

const TBody = (props) => {
  return (
    <tbody className={props.className}>{props.children}</tbody>
  )
}            

const EmptyRowAlert = ({ icon = "fas fa-inbox" }) =>{
  const {currentUser} = useCurrentUserHook()
  const {labelLocale:tableHeadLocale} = usePageLocale(currentUser.current_locale, 'commonPageLocale')

  return(
    <div className="flex coldir aligncenter justifycenter gap-10 p-40">
      <i className={`${icon} font-40 text-gray`} />
      <div className="text-center f16 fw500 text-gray">
        {tableHeadLocale('no_data')}
      </div>
    </div>
  )
}

export {Table, THead, TH, TR, TD, TBody, EmptyRowAlert};